import React from 'react';
import MainLayout from 'components/MainLayout';
import HeaderInside from 'components/HeaderInside';
import { SearchQuestion } from './components/SearchQuestions';

const NewQuestions: React.FC = () => {
  return (
    <MainLayout title="Questões" className="home">
      <div style={{ padding: '20px' }}>
        <HeaderInside
          title="Questões"
          subtitle="Pesquise pelo código, enunciado, módulo, família, capítulo e provas que a pergunta caiu. Suas respostas não serão salvas no banco de dados e não influenciarão nos seus relatórios :)"
        />
        <SearchQuestion />
      </div>
    </MainLayout>
  );
};

export default NewQuestions;
